module.exports = __webpack_public_path__ + "img/add-white.75d8ec37.svg";